import { createSlice } from '@reduxjs/toolkit'

import type { IEquipmentNode } from '@web/entities/equipment/model/types'
import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'

import type { PayloadAction } from '@reduxjs/toolkit'

export interface IEquipmentNodeState {
  nodes: IEquipmentNode[]
}

const initialState: IEquipmentNodeState = {
  nodes: []
}

const equipmentNodeSlice = createSlice({
  name: 'equipment-nodes',
  initialState,
  reducers: {
    setNodes(state, action: PayloadAction<IEquipmentNode[]>) {
      state.nodes = action.payload
    }
  }
})

export const equipmentNodeReducer = equipmentNodeSlice.reducer
export const useEquipmentNodeActions = () =>
  useDispatchedActions(equipmentNodeSlice.actions)
